import React from "react"

import { ClarificationRequestForm } from "entities/clarification-requests/ui/ClarificationRequestForm"

import { useProductPositionFormCoreContext } from "../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormFeaturesContext } from "../contexts/ProductPositionFormFeaturesContext"

export const ProductPositionFormClarificationRequest = React.memo(() => {
  const { isReadonly } = useProductPositionFormCoreContext()
  const { clarificationRequest } = useProductPositionFormFeaturesContext()

  if (!clarificationRequest) return null

  const cr = clarificationRequest.data.clarificationRequest
  const hasCR = !!cr?.data
  const { lastUpdatedByMember } = clarificationRequest.data.meta

  return (
    <ClarificationRequestForm.Root
      clarificationRequest={cr?.data ?? null}
      isLoading={cr?.isLoading}
      lastUpdatedByMember={lastUpdatedByMember}
    >
      {hasCR ? <ClarificationRequestForm.UpdatedAt /> : null}
      <ClarificationRequestForm.TextArea
        name="clarificationRequest.content"
        readonly={isReadonly}
      />
      {hasCR && isReadonly && clarificationRequest.handlers.onDelete ? (
        <ClarificationRequestForm.DismissButton
          onDismiss={clarificationRequest.handlers.onDelete}
        />
      ) : null}
      {!isReadonly && clarificationRequest.data.meta.shouldShowHint && (
        <ClarificationRequestForm.Hint
          onClose={clarificationRequest.handlers.onHintClose}
        />
      )}
    </ClarificationRequestForm.Root>
  )
})
